import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=e8d4828a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d4828a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8d4828a')) {
      api.createRecord('e8d4828a', component.options)
    } else {
      api.reload('e8d4828a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=e8d4828a&scoped=true&", function () {
      api.rerender('e8d4828a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21y67tErl5yTr/JS/comp/Accordion.vue"
export default component.exports